import { schoolLogo } from "@/constants";
import React from "react";

const SchoolTiles = () => {
  return (
    <div className="mt-3">
      <div className="grid grid-cols-3 justify-between">
        {schoolLogo.map((school, index) => (
          <div key={index}>
            <div className="w-fit rounded-lg p-2">
              <img
                src={school.img}
                alt="network-logo"
                className="size-20 rounded-lg object-cover"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SchoolTiles;
